import { useState, useEffect } from 'react'
import SharedLinkForm from './shared_link_form'
import SharedLinkEmailForm from './shared_link_email_form'
import CopyInput from '../copy_input'
import Tooltip from '../tooltip'

const SharedLink = ({
  link,
  objectSettings,
  deleteLink,
  isOwner,
  getLinks,
  scope_type,
  scope_id,
  settingsMode,
  disabledEmails
}) => {
  const [visibleForm, setVisibleForm] = useState(false)
  const [visibleEmailsForm, setVisibleEmailsForm] = useState(false)

  useEffect(() => {
    if (visibleForm) setVisibleEmailsForm(false)
  }, [visibleForm])

  useEffect(() => {
    if (visibleEmailsForm) setVisibleForm(false)
  }, [visibleEmailsForm])

  const tabNames = () => {
    let names = []

    link.tabs.map((tab) => {
      let findedTab = objectSettings.tabs.filter((tb) => tb.codename == tab)[0]
      if (findedTab) names.push(findedTab.name)
    })

    return names.join(', ')
  }

  return (
    <>
      <tr>
        <td>{link.name}</td>
        {settingsMode ? (
          <td>
            {link.sharable_trashed ? (
              <span className="text-strike text-muted">{link.sharable_name}</span>
            ) : (
              <a href={link.sharable_url}>{link.sharable_name}</a>
            )}
          </td>
        ) : null}
        {isOwner ? <td>{link.user_name}</td> : null}
        <td>{objectSettings && objectSettings.tabs && objectSettings.tabs.length && tabNames()}</td>
        <td>
          <CopyInput text={link.share_url} hideText={true} />
        </td>
        <td>
          <Tooltip content={I18n.t('shared-link-copy-tooltip')} placement="bottom">
            <i className="fa fa-question-circle"></i>
          </Tooltip>
        </td>
        <td className="text-right nowrap">
          <span className="pull-right">
            {!disabledEmails ? (
              <a
                className="pointer-cursor btn btn-clean btn-icon"
                onClick={() => setVisibleEmailsForm(!visibleEmailsForm)}
              >
                <i className="fa-light fa-envelope"></i>
              </a>
            ) : null}
            {!settingsMode ? (
              <a className="pointer-cursor btn btn-clean btn-icon" onClick={() => setVisibleForm(!visibleForm)}>
                <i className="fa-light fa-pen"></i>
              </a>
            ) : null}
            <a className="pointer-cursor btn btn-clean btn-icon" onClick={deleteLink}>
              <i className="fa-light fa-trash"></i>
            </a>
          </span>
        </td>
      </tr>
      {visibleForm && !settingsMode && (
        <tr>
          <td colSpan="99">
            <SharedLinkForm
              getLinks={getLinks}
              uuid={link.id}
              link={link}
              setVisibleForm={setVisibleForm}
              scope_type={scope_type}
              scope_id={scope_id}
              objectSettings={objectSettings}
            />
          </td>
        </tr>
      )}
      {visibleEmailsForm && (
        <tr>
          <td colSpan="99">
            <SharedLinkEmailForm
              getLinks={getLinks}
              uuid={link.id}
              link={link}
              setVisibleEmailsForm={setVisibleEmailsForm}
              scope_type={scope_type}
              scope_id={scope_id}
              settingsMode={settingsMode}
            />
          </td>
        </tr>
      )}
    </>
  )
}

export default SharedLink
